import React from 'react';

const Button = ({ text, onClick }) => {
  return (
    <button className="customButton" onClick={onClick}>
      {text}
    </button>
  );
};

export default Button;
